import React from "react";
import "./Projects.css"

const LevelSelect = ({
    onSelect,
    onBack
}) => {

    return (
        <div className="projects-screen">

            <div className="projects-topbar">

                <button
                    type="button"
                    className="back-button"
                    onClick={onBack}
                >
                    ← Back
                </button>

            </div>


            <div className="projects-header">

                <h1>
                    Choose Your Level
                </h1>

                <p>
                    Select the level that matches
                    your experience.
                </p>

            </div>


            <div className="project-choice-grid">

                <button
                    type="button"
                    className="project-choice-card"
                    onClick={() => onSelect("beginner")}
                >

                    <div className="project-choice-icon">
                        1
                    </div>

                    <div className="project-choice-content">

                        <h2>
                            Beginner
                        </h2>

                        <p>
                            Learn the fundamentals of
                            space robotics programming.
                        </p>

                    </div>

                    <div className="project-choice-arrow">
                        →
                    </div>

                </button>


                <button
                    type="button"
                    className="project-choice-card"
                    onClick={() => onSelect("experienced")}
                >

                    <div className="project-choice-icon">
                        2
                    </div>

                    <div className="project-choice-content">

                        <h2>
                            Experienced
                        </h2>

                        <p>
                            Work with more challenging
                            robotics programming tasks.
                        </p>

                    </div>

                    <div className="project-choice-arrow">
                        →
                    </div>

                </button>

            </div>

        </div>
    );
};

export default LevelSelect;